
const notificationEvents = new EventTarget();

export const showNotification = (message, type = 'success') => {
    const event = new CustomEvent('show-notification', {
        detail: { message, type }
    });
    notificationEvents.dispatchEvent(event);
};

export const subscribeToNotifications = (callback) => {
    const handler = (event) => callback(event.detail);
    notificationEvents.addEventListener('show-notification', handler);
    return () => notificationEvents.removeEventListener('show-notification', handler);
};
